import { render } from "./sub-sort.vue?vue&type=template&id=7a216bd8&scoped=true"
import script from "./sub-sort.vue?vue&type=script&lang=js"
export * from "./sub-sort.vue?vue&type=script&lang=js"

import "./sub-sort.vue?vue&type=style&index=0&id=7a216bd8&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a216bd8"]])

export default __exports__